import Slider from "react-slick";
import { CommonButton } from "../ui/CommonButton";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export const LiveAccount = ({
  icon,
  heading,
  buttonSize,
  buttontext,
  footerText,
  ibAccounts = [],
  otherData,
  type = "live_account",
  userAccountData = [],
  handleDepositLiveAccount,
  dwtype
}) => {
  const getAccountList = () => {
    if (type === "live_account" && Array.isArray(ibAccounts)) return ibAccounts;
    if (type === "partner_account" && Array.isArray(userAccountData)) return userAccountData;
    return [];
  };

  const accounts = getAccountList();
  const shouldUseCarousel = accounts.length > 0;

  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 2 } },
      { breakpoint: 768, settings: { slidesToShow: 1 } }
    ]
  };

  const formatDate = (isoString) => {
    if (!isoString) return "N/A";
    const date = new Date(isoString);
    return date.toLocaleDateString(undefined, {
      year: "numeric",
      month: "short",
      day: "numeric"
    });
  };

  const InfoGroup = ({ label, value }) => (
    <div className="flex flex-col">
      <span className="text-sm text-gray-500">{label}</span>
      <span className="font-semibold text-gray-800 truncate">{value || "0"}</span>
    </div>
  );

  const AccountCard = ({ account }) => {
    const isPartner = type === "partner_account";
    const fullName = `${account.fname || ""} ${account.lname || ""}`.trim();

    return (
      <div className="w-full h-full bg-white rounded-xl shadow-md p-6 flex flex-col justify-between border-t-[5px] border-iconbgcolor hover:shadow-lg transition-shadow">
        {/* Top Header */}
        <div className="flex items-start justify-between mb-4">
          <div>
            <div className="text-lg font-bold text-blue-600">
              {isPartner ? fullName : heading}
            </div>
            <div className="text-sm text-gray-500">
              {isPartner ? `Account No: ${account.accountno}` : `Account No: ${account.accountNo}`}
            </div>
          </div>
          <div className="bg-iconbgcolor text-white p-3 rounded-md shadow">
            {icon}
          </div>
        </div>

        {/* Info Body */}
        <div className="grid grid-cols-2 gap-4 text-sm text-gray-700 mb-4">
          {isPartner ? (
            <>
              <InfoGroup label="Email" value={account.email} />
              <InfoGroup label="Mobile" value={`${account.countryCode || ""} ${account.mobile}`} />
              <InfoGroup label="Currency" value={account.currency} />
              <InfoGroup label="Account Type" value={account.actype || account.actype || "N/A"} />
               <InfoGroup label="Balance" value={account.balance || account.balance || "0"} />
              <InfoGroup label="Created On" value={formatDate(account.createdAt)} />
            </>
          ) : (
            <>
              <InfoGroup label="Balance" value={`$${account.balance}`} />
              <InfoGroup label="Currency" value={otherData?.currency || "N/A"} />
            </>
          )}
        </div>

     
       {
        !isPartner &&  <div className="flex items-center justify-between text-sm font-medium text-textcolorgray500 pt-4 border-t border-gray-200 mt-auto">
          <span className="text-sm font-bold text-black">{footerText}</span>
          <CommonButton onClick={()=>handleDepositLiveAccount(account,dwtype)} text={buttontext || "Submit"} size={buttonSize} />
        </div>
       }
      </div>
    );
  };

  if (accounts.length === 0) {
    return (
      <div className="w-full px-4 my-10 flex justify-center items-center text-gray-400 text-lg font-medium min-h-[200px]">
        No data to show
      </div>
    );
  }

  return (
    <div className="w-full px-4 my-10 overflow-visible">
      {shouldUseCarousel ? (
        accounts.length === 1 ? (
          // Single Card Left-Aligned Full Column
          <div className="w-full flex">
            <div className="w-full max-w-full md:max-w-[33.333%] px-2">
              <AccountCard account={accounts[0]} />
            </div>
          </div>
        ) : (
          // Carousel for Multiple
          <Slider {...settings}>
            {accounts.map((acc) => (
              <div key={acc._id} className="px-2">
                <AccountCard account={acc} />
              </div>
            ))}
          </Slider>
        )
      ) : (
        accounts.map((acc) => (
          <div key={acc._id} className="py-5">
            <AccountCard account={acc} />
          </div>
        ))
      )}
    </div>
  );
};
